/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ minutes: NonNullable<unknown> }} Features_Today_InInputs */

const en_features_today_in = /** @type {(inputs: Features_Today_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`in ${i?.minutes} min`)
};

const pl_features_today_in = /** @type {(inputs: Features_Today_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`za ${i?.minutes} min`)
};

/**
* | output |
* | --- |
* | "in {minutes} min" |
*
* @param {Features_Today_InInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_today_in = /** @type {((inputs: Features_Today_InInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Today_InInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_today_in(inputs)
	return en_features_today_in(inputs)
});